<template>
  <form v-on:submit.prevent="submitForm">

    <h2>Currencies</h2>
    <div class="form-group"><label for="id">ID :</label><input class="form-control" id="id" readonly="readonly" v-model="currency.id"/></div>
    <div class="form-group"><label for="currencyCode">Currency Code : </label><input class="form-control" id="currencyCode" v-model="currency.currencyCode"/></div>
    <div class="form-group"><label for="displayCode">Display Code : </label><input class="form-control" id="displayCode" v-model="currency.displayCode"/></div>
    <div class="form-group"><label for="isoCode">Iso Code : </label><input class="form-control" id="isoCode" v-model="currency.isoCode"/></div>
    <div class="form-group"><label for="decimalNumber">Decimal Number : </label><input class="form-control" id="decimalNumber" v-model="currency.decimalNumber"/></div>
    <div class="form-group"><label for="begin">Begin : </label><input class="form-control" id="begin" v-model="currency.begin"/></div>
    <div class="form-group"><label for="end">End : </label><input class="form-control" id="end" v-model="currency.end"/></div>
    <div>
      <p>
        <input class="btn btn-edit" type="submit" value="Submit">
      </p>

      <p class="btn btn-deprecate" @click="deprecateCurrency()">
        <v-icon> mdi-clock </v-icon>
        <input class="btn" value="Deprecate">
      </p>

      <p>
        <router-link class="btn btn-cancel" v-bind:to="{path: 'currencies'}">
          <v-icon>mdi-cancel</v-icon>
          <input class="btn" type="submit" value="Cancel">
        </router-link>
      </p>
    </div>
  </form>
</template>

<script>
import {parameters} from "../../parameters";
import {httpClient} from "../../requesters/httpClient";

export default {
  name: 'EditCurrency',

  async created() {
    await httpClient.get(`${parameters.posdataRefUrl}/currencies/` + this.$route.query.id)
      .then((response)=> {
        this.currency = response.data;
      })
      .catch((error)=> {
        throw error;
      });
  },
  data() {
    return {
      currency : {}
    }
  },
  methods: {
    async submitForm(e) {

      if (!this.areFieldsEmpty()) {
        await httpClient.post(`${parameters.posdataRefUrl}/overwrite/currency`, this.currency);

        await this.$alert("The currency was overwritten THEN updated");

        await this.$router.push('currencies');

        e.preventDefault();
      } else {
        await this.$alert("Some mandatory fieds are empty")
      }
    },
    areFieldsEmpty: function(){
      if (this.currency.currencyCode === '' || this.currency.displayCode === ''
      || this.currency.isoCode === '' || this.currency.decimalNumber === ''){
        return true;
      }
    },
    async deprecateCurrency(){
      await httpClient.post(`${parameters.posdataRefUrl}/currency/` + this.currency.id + `/deprecate`)
            .then(function (response){
              if (response.status === 200){
                alert("The currency was deprecated")
              } else {
                alert("Currency is not present in database and can't be deprecated")
              }

      })
      await this.$router.push('currencies')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/currencies/EditCurrency.vue